import React from 'react';
import styled from 'styled-components';
import { SparkContentLoader } from '@sparknz/spark-pattern-library';

const FullWidthContentLoader = styled(SparkContentLoader)`
  width: '100%';
`;

const InformationLayerLoader = () => {
  return (
    <FullWidthContentLoader height={400}>
      <rect x="0" y="20" rx="3" ry="3" width="280" height="30" />
      <rect x="0" y="80" rx="3" ry="3" width="280" height="20" />
      <rect x="0" y="110" rx="3" ry="3" width="280" height="20" />
      <rect x="0" y="140" rx="3" ry="3" width="130" height="20" />
      <rect x="0" y="190" rx="3" ry="3" width="280" height="20" />
      <rect x="0" y="220" rx="3" ry="3" width="170" height="20" />
      <rect x="0" y="270" rx="3" ry="3" width="280" height="20" />
      <rect x="0" y="300" rx="3" ry="3" width="180" height="20" />
      <rect x="0" y="330" rx="3" ry="3" width="60" height="20" />
    </FullWidthContentLoader>
  );
};

export default InformationLayerLoader;
